import React from "react";
import { UserTable } from "../../../users/components/UserTable/UserTable";
import { UserFilter } from "../../../users/components/UserFilter/UserFilter";
import { EditUserModal } from "../../../users/components/EditUserModal/EditUserModal";
import { CreateUserModal } from "../../../users/components/CreateUserModal/CreateUserModal";
import { useUsersTab } from "./useUsersTab";
import { ResourceTab } from "../../../../shared/components/layout/ResourceTab";
import { ActionButton } from "../../../../shared/components/layout/ActionButton";

export const UsersTab: React.FC<ReturnType<typeof useUsersTab>> = (props) => {
  const {
    usersResource,
    selectedUser,
    handleEditUser,
    handleCloseEditModal,
    handleUpdateUser,
    handleOpenCreateModal,
    isUpdating,
    statusOptions,
    defaultValues,
    handleCloseCreateModal,
    handleCreateUser,
    isCreateModalOpen,
    isCreating,
    activeUsersCount,
  } = props;

  return (
    <ResourceTab
      resource={{
        data: usersResource.data,
        isLoading: usersResource.isLoading,
        isError: usersResource.isError,
        page: usersResource.page,
        pageSize: usersResource.pageSize,
        handlePageChange: usersResource.handlePageChange,
        handlePageSizeChange: usersResource.handlePageSizeChange,
      }}
      filtersComponent={
        <UserFilter
          name={usersResource.filters.name}
          citizenshipNumber={usersResource.filters.citizenship_number}
          onNameChange={(v) => usersResource.handleFilterChange("name", v)}
          onCitizenshipChange={(v) =>
            usersResource.handleFilterChange("citizenship_number", v)
          }
          onClearFilters={usersResource.resetFilters}
        />
      }
      tableComponent={
        <UserTable
          users={usersResource.data!}
          isLoading={usersResource.isLoading}
          isError={usersResource.isError}
          page={usersResource.page}
          pageSize={usersResource.pageSize}
          onPageChange={usersResource.handlePageChange}
          onPageSizeChange={usersResource.handlePageSizeChange}
          onEditUser={handleEditUser}
          activeUsersCount={activeUsersCount}
        />
      }
      headerAction={
        <ActionButton onClick={handleOpenCreateModal} label="Nuevo" />
      }
      emptyStateMessage="No hay usuarios para mostrar."
      editModal={
        selectedUser ? (
          <EditUserModal
            open={!!selectedUser}
            onClose={handleCloseEditModal}
            defaultValues={defaultValues}
            onSubmit={handleUpdateUser}
            isSubmitting={isUpdating}
            statusOptions={statusOptions}
          />
        ) : undefined
      }
      createModal={
        <CreateUserModal
          open={isCreateModalOpen}
          onClose={handleCloseCreateModal}
          defaultValues={{ name: "", citizenship_number: "" }}
          onSubmit={handleCreateUser}
          isSubmitting={isCreating}
        />
      }
    />
  );
};
